module.exports = __webpack_public_path__ + "static/media/staff_karolina_merda.0a927f4e.jpg";